module.exports = __webpack_public_path__ + "static/template_3_about_us-4c401283b1e4a2a20a8b6ec540aaa263.png";